export const ADDON_PACKAGES = [
  {
    code: 'addon_10_artes',
    title: '10 artes',
    arts: 10,
    priceLabel: 'R$ 49',
  },
  {
    code: 'addon_25_artes',
    title: '25 artes',
    arts: 25,
    priceLabel: 'R$ 119',
  },
  {
    code: 'addon_50_artes',
    title: '50 artes',
    arts: 50,
    priceLabel: 'R$ 249',
  },
  {
    code: 'addon_100_artes',
    title: '100 artes',
    arts: 100,
    priceLabel: 'R$ 499',
  },
];
